import { Component, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { OrganisationFacade } from '@app/store/organisation';

@Component({
    selector: 'app-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.css'],
    imports: [TranslateModule, ButtonModule],
})
export class DeleteButtonComponent {
    private readonly organisationFacade = inject(OrganisationFacade);
    private readonly confirmationService = inject(ConfirmationService);
    private readonly translateService = inject(TranslateService);

    readonly organisationId = input.required<string>();
    readonly saving = input<boolean>(false);
    readonly testId = input.required<string>();

    onDelete(): void {
        this.confirmationService.confirm({
            header: this.translateService.instant('organisations.delete.header'),
            message: this.translateService.instant('organisations.delete.message'),
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: this.translateService.instant('organisations.delete.reject'),
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: this.translateService.instant('organisations.delete.accept'),
                severity: 'danger',
            },
            accept: () => {
                this.organisationFacade.deleteOrganisation(this.organisationId());
            },
        });
    }
}
